// extracted by mini-css-extract-plugin
export var wrapper = "MarkdownColumnsWrapper-module--wrapper--8cd76";